import React from 'react';
import { Link } from 'react-router-dom';

function ExampleMA() {
    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold mb-6">Example Microaggression</h1>

            <div className="space-y-8">
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h2 className="text-xl font-semibold mb-2">Original Microaggression</h2>
                    <p className="text-sm text-gray-500 mb-4 italic">
                        *An example of microaggression sampled from SelfMA dataset
                    </p>
                    <p className="text-gray-700 leading-relaxed text-lg">
                        At a loud party, a woman engineer spells a word using the phonetic alphabet (alpha, bravo, charlie,...).
                        A man at the party responds by asking, "Wow, was your dad a pilot?"
                    </p>
                    <div className="mt-4">
                        <img
                            src={`${process.env.PUBLIC_URL}/alpha-bravo-charlie.png`}
                            alt="Alpha Bravo Charlie Example"
                            className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                        />
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md">
                    <h2 className="text-xl font-semibold mb-2">Analogical Microaggression</h2>
                    <p className="text-sm text-gray-500 mb-4 italic">
                        *An example generated by EmoSync
                    </p>
                    <p className="text-gray-700 leading-relaxed text-lg">
                        Doe is a successful businessman who has worked hard to build his company.
                        At a networking event, a stranger assumes that Doe is a maintenance worker
                        because of his Hispanic appearance, asking him to fix a broken light.
                    </p>
                    <div className="mt-4">
                        <img
                            src={`${process.env.PUBLIC_URL}/doe-light.png`}
                            alt="Doe Light Example"
                            className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                        />
                    </div>
                </div>
            </div>

            <div className="mt-8">
                <Link
                    to="/"
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark"
                >
                    Back to Home
                </Link>
            </div>
        </div>
    );
}

export default ExampleMA; 